import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-loader',
  standalone: false,
  template: `
    <div class="overlay fx fx--center">
      <mat-progress-spinner class="loader" mode="indeterminate">
      </mat-progress-spinner>
    </div>
  `,
  styleUrls: ['./loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoaderComponent {

  constructor() {
  }

}
